/**
 * @generated SignedSource<<ebfae8f9a7b7361624fdc00f3650b4e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ImportQuickbooksCustomersInput = {
  qboCustomers?: ReadonlyArray<QuickbooksCustomerInput | null> | null;
  resolutions?: ReadonlyArray<QuickbooksClientMatchResolution> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type QuickbooksCustomerInput = {
  id?: string | null;
  realmId?: string | null;
};
export type QuickbooksClientMatchResolution = {
  customerId: string;
  realmId: string;
  clientId: number;
};
export type ImportQuickbooksCustomersReviewedMutation$variables = {
  input: ImportQuickbooksCustomersInput;
};
export type ImportQuickbooksCustomersReviewedMutation$data = {
  readonly importQuickbooksCustomers: {
    readonly company: {
      readonly clients: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly name: string;
            readonly notes: string | null;
            readonly logoId: string | null;
            readonly logoDefaultId: number | null;
            readonly projectCount: number | null;
            readonly xeroContactId: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly unlinkedConfirmedCount: number | null;
  } | null;
};
export type ImportQuickbooksCustomersReviewedMutation = {
  variables: ImportQuickbooksCustomersReviewedMutation$variables;
  response: ImportQuickbooksCustomersReviewedMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10000
    }
  ],
  "concreteType": "ClientTypeConnection",
  "kind": "LinkedField",
  "name": "clients",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Client",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "notes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "logoId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "logoDefaultId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "xeroContactId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "clients(first:10000)"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unlinkedConfirmedCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportQuickbooksCustomersReviewedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ImportQuickbooksCustomersPayload",
        "kind": "LinkedField",
        "name": "importQuickbooksCustomers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportQuickbooksCustomersReviewedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ImportQuickbooksCustomersPayload",
        "kind": "LinkedField",
        "name": "importQuickbooksCustomers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "764bade8c00df848ef358e68e7429f6d",
    "id": null,
    "metadata": {},
    "name": "ImportQuickbooksCustomersReviewedMutation",
    "operationKind": "mutation",
    "text": "mutation ImportQuickbooksCustomersReviewedMutation(\n  $input: ImportQuickbooksCustomersInput!\n) {\n  importQuickbooksCustomers(input: $input) {\n    company {\n      clients(first: 10000) {\n        edges {\n          node {\n            id\n            name\n            notes\n            logoId\n            logoDefaultId\n            projectCount\n            xeroContactId\n          }\n        }\n      }\n      id\n    }\n    unlinkedConfirmedCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "04a01a5af05e85efcb34403fe0864b07";

export default node;
